<script>
  export let color = "";
</script>

<div class="shade-container">
  <span class="shade" style="background-color: {color}" />
  <span class="shade-text" style="font-size: .8rem;">{color.toUpperCase()}</span
  >
  <a
    href="#"
    class="copy-icon"
    on:click={() => {
      const cb = navigator.clipboard;
      cb.writeText(color).then(() => alert("Color copied"));
    }}
  />
</div>

<style>
  div.shade-container {
    display: flex;
    flex-direction: column;
    width: 70px;
    height: 80px;
    border: 1px solid gray;
    margin: 3px;
  }
  span.shade {
    display: block;
    width: 100%;
    height: 55%;
  }
  span.shade-text {
    display: block;
    width: 100%;
    height: 20%;
    border-top: 3px outset gray;
    text-align: center;
    color: #fff;
    background-color: #000;
    /* font-size: 0.8rem;
    font-family: "Gothic A1", sans-serif; */
  }

  .copy-icon {
    width: 16px;
    height: 20px;
    background-color: lightgray;
    background-image: url(copy.png);
    background-size: cover;
    margin: 6px auto;
  }
</style>
